import React from 'react';
import ReactDatePicker from 'react-datepicker';
import css from 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import NumberSelector from './NumberSelector'

export default function DatePicker(props) {
  const id = props.id || 'input-' + props.name;
  // const date = props.value ? new Date(props.value) : new Date(0);
  const value = props.value ? moment(props.value, 'YYYY-MM-DD') : '';
  const handleChange = (newDate) => {
    let newValue = null;
    if (newDate) {
      // newDate.hours(date.getUTCHours());
      // newDate.minutes(date.getUTCMinutes());
      // newValue = newDate.toISOString();
      newValue = moment(newDate).format('YYYY-MM-DD');
    }
    console.log('nd', newValue)
    if (props.onChange) props.onChange({name: props.name, value: newValue});
    else console.log(props.name, newValue);
  };
  let labelClassName = null;
  let inputDivClassName = null;
  if (props.horizontal) {
    labelClassName = "col-sm-3 control-label";
    inputDivClassName = "col-sm-9";
  }
  let formGroupClassName = 'form-group';
  if (props.error) formGroupClassName += ' has-error';
  const label = props.label === null ? null
  : (<label htmlFor={id} className={labelClassName}>
    {props.label || props.name}
  </label>);
  const message = props.error || props.message;
  return (
    <div className={formGroupClassName}>
      {label}
      <div className={inputDivClassName}>
        <ReactDatePicker
          autoComplete="false"
          locale={props.locale || 'en-gb'}
          minDate = {props.minValue}
          maxDate = {props.maxValue}
          openToDate = {props.openToDate}
          id={ id }
          selected={value}
          dateFormat="YYYY-MM-DD"
          isClearable={true}
          onChange={handleChange}
          className="form-control"
        />
        <span className="help-block">{message}</span>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/DatePicker.jsx